import React, { useState, useCallback, useEffect, useRef, createRef } from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import { useQuery } from "../../../../../hooks/common";
import { getLowerPrice, getDelPrice, unitPrice, getDelPriceWithVariant, getLowerPriceWithVariant, getAddOnLowerPrice, getAddOnDelPrice, getPrices } from "../../../../../../utils/product";
import { FormattedMessage, useIntl } from "react-intl";
import ProductStarScore, { OneStar } from "../../../module/product-star-score";
import ProductShare from "../../product-share/index";
import { useSelector } from "react-redux";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import { isIOS, isMacOs } from 'react-device-detect'
import { Iconfont } from "../../../../../components/icon/iconfont";
// import PaypalMessage from '../../../../../components/paypal-message'
import Mask from "../../../../../components/alert/mask";
import PayMessages from "../../../../../components/pay-messages"
import PriceDiscountAlert, { DiscountAlert } from "../price-discount-alert";
import AddToWish from "../../../module/addtowish";


const StagingMask = props => {
    useStyles(classes)
    const { href, onClose, lower } = props
    let frameHref = href
    let reg = /^\//
    if (!reg.test(frameHref)) {
        frameHref = '/' + frameHref
    }
    if (href?.indexOf('?') != -1) {
        frameHref += '&isApp=1&total=' + lower
    } else {
        frameHref += '?isApp=1&total=' + lower
    }
    return <React.Fragment>
        <Mask onClick={() => onClose()} />
        <div className={classes.stagingMask}>
            <Iconfont className={classes.stagingClose} onClick={() => onClose()}>&#xe7c9;</Iconfont>
            <iframe src={frameHref} frameborder="0"></iframe>
        </div>
    </React.Fragment>
}

const StagingInfoBox = props => {
    useStyles(classes)
    const { instalments, lower } = props
    const [showMask, setShowMask] = useState(false)
    return <div className={classes.stagingBox}>
        {
            instalments?.icon &&
            <img src={instalments?.icon} alt="" />
        }
        {
            instalments?.text && instalments?.href &&
            <span onClick={() => setShowMask(true)}>{instalments?.text}</span>
        }
        {
            showMask &&
            <StagingMask href={instalments?.href} lower={lower} onClose={() => setShowMask(false)} />
        }
    </div>
}

const BasicInformation = props => {
    useStyles(classes);
    const { productHooks, reviewItem, pageProduct, showProm, setShowProm, showAddToCartModal, setShowAddToCartModal, setShowBtnEstimatedPrice } = props;
    const { selectedProduct, stagingInfo, selectedVariant, productAddToCart, carting, estimatedPercent } = productHooks;
    const [showShareModal, setShowShareModal] = useState(false)
    const [earnPoints, setEarnPoints] = useState(false)
    const intl = useIntl();
    const { productVO } = pageProduct
    const { couponActivity } = productVO
    const { instalments } = productVO?.products?.[0] || {}

    const global = useSelector(state => state.global);
    const { config } = global;

    const query = useQuery();
    const isAddOn = query?.product_type == 'addOn'
    const isGift = query?.product_type == 'gift'
    const priceRef = createRef();

    useEffect(() => {
        let ob = new IntersectionObserver(obHandle)
        ob.observe(priceRef.current)
        return () => {
            ob.disconnect()
        }
    }, [])

    const obHandle = entries => {
        const entry = entries?.[0]
        if (entry?.intersectionRatio > 0) {
            // 目标元素进入视口
            setShowBtnEstimatedPrice(false)
        } else {
            // 目标元素离开视口
            setShowBtnEstimatedPrice(true)
        }
    }

    const handleClick = useCallback(() => {
        if (isIOS || isMacOs) {
            setTimeout(() => {
                window.location.href = `https://itunes.apple.com/us/app/chic-me-shopping-sharing-saving/id${config?.app.ios.id}?l=zh&ls=1&mt=8`;
            }, 200);
            window.location.href = `chic-me://chic.me/product?id=${selectedProduct?.id}`;
        } else {
            setTimeout(() => {
                window.location.href = `https://play.google.com/store/apps/details?id=${config?.app.android.id}`;
            }, 200);
            window.location.href = `chic-me://chic.me/product?id=${selectedProduct?.id}`;
        }
    }, [])

    // const earnPointsEvent = () => {
    //     setEarnPoints(true);

    //     setTimeout(() => {
    //         setEarnPoints(false);
    //     }, 3000);
    // }
    const isEstimated = selectedProduct?.estimatedPrice && !isAddOn && !isGift

    const lower = selectedVariant && !isAddOn ?
        getLowerPriceWithVariant(selectedVariant) :
        isAddOn ?
            getAddOnLowerPrice(selectedProduct) :
            getLowerPrice(selectedProduct)
    const higher = selectedVariant && !isAddOn ?
        getDelPriceWithVariant(selectedVariant) :
        isAddOn ?
            getAddOnDelPrice(selectedProduct) :
            getDelPrice(selectedProduct)

    if (query?.product_type == 'gift') {
        lower.amount = "0.00"
    }

    let off = 0
    if (higher) {
        off = Math.round((Number(higher.amount) - Number(lower.amount)) * 100 / Number(higher.amount))
    }

    let prices = []
    if (selectedProduct?.variants) {
        prices = getPrices(selectedProduct?.variants)
    }

    const shouldShowPrices = prices.length > 1 && !isAddOn && !isGift && !selectedVariant

    return <div className={classes.MproductInfoContainer}>
        <div className={classes.MproductBaiscInfo}>
            {
                selectedProduct?.icon1 && <div className={classes.MproductPromotionPic}>
                    <img src={selectedProduct?.icon1} alt="Icon1" />
                </div>
            }

            <div className={classes.MproductBaiscInfoBox}>
                <div className={classes.ShareNameContainer}>
                    <div className={classes.MproductName}>
                        {
                            selectedProduct?.flag && <span className={`${classes.MpNew} ${classes.PreFall}`}><span>{selectedProduct.flag}</span></span>
                        }

                        {
                            !selectedProduct?.flag && selectedProduct?.isNew && !selectedProduct?.isPreOrder && <a href="/i/new" className={classes.MpNew}>
                                <span><FormattedMessage id="new" defaultMessage="NEW" /></span>
                            </a>
                        }

                        {
                            selectedProduct?.isPreOrder && <span className={classes.PreOrderFlag}>Pre order</span>
                        }

                        <h1 className={classes.Name}>
                            {
                                query?.geeko_ads ? (selectedProduct?.adName ?? selectedProduct?.name) : (selectedProduct?.name)
                            }
                        </h1>
                    </div>

                    <React.Fragment>
                        {
                            reviewItem?.total > 0 && <div className={classes.ReviewCount} onClick={props?.onShow}>
                                <OneStar starScore={reviewItem?.avgScore || 0} />
                                <span className={`${classes.Iconfont} iconfont`}>&#xe690;</span>
                            </div>
                        }
                    </React.Fragment>
                </div>

                <div className={classes.mProductPrices}>
                    {
                        shouldShowPrices ? <div className={classes.PriceItem}>
                            <span className={classes.RealPrice} ref={priceRef} style={{ color: (higher ? "#e64545" : "#222") }}>
                                {unitPrice(prices[0])}-{unitPrice(prices[1])}
                            </span>
                        </div> : <div className={classes.PriceItem}>
                            <span className={classes.RealPrice} ref={priceRef} style={{ color: (higher ? "#e64545" : "#222") }}>
                                {
                                    query?.product_type && selectedProduct?.giftPrice ?
                                        (unitPrice(selectedProduct?.giftPrice) || '-') :
                                        (unitPrice(lower) || '-')
                                }
                            </span>

                            {/* {
                            isEstimated && */}
                            <PriceDiscountAlert
                                isEstimated={isEstimated}
                                showProm={showProm}
                                setShowProm={setShowProm}
                                showAddToCartModal={showAddToCartModal}
                                setShowAddToCartModal={setShowAddToCartModal}
                                selectedVariant={selectedVariant}
                                selectedProduct={selectedProduct}
                                productAddToCart={productAddToCart}
                                carting={carting}
                                per={estimatedPercent}
                                amount={selectedProduct?.estimatedPrice}
                                couponActivity={couponActivity}
                                lower={lower}
                            />
                            {/* } */}

                            {
                                query?.product_type != 'gift' && <>
                                    {
                                        higher && <del className={classes.MrspPrice}>{unitPrice(higher)}</del>
                                    }
                                    {
                                        off > 0 && <span className={classes.DiscountPercent}>{`-${off}%`}</span>
                                    }
                                </>
                            }

                            {
                                isEstimated && <Iconfont className={classes.toPageIcon} onClick={() => {
                                    if (window.GeekoSensors) {
                                        window.GeekoSensors.Track('ELClick', {
                                            clicks: "estimated_price",
                                        })
                                    }
                                    setShowProm(true)
                                }}>&#xe694;</Iconfont>
                            }
                        </div>
                    }

                    <AddToWish productId={selectedProduct?.id} className={classes.AddToWish} />
                </div>
            </div>
        </div>

        {
            instalments &&
            <StagingInfoBox instalments={instalments} lower={lower?.amount} />
        }

        {/* {
            global?.config?.paypal?.showMessage && <PaypalMessage money={lower} country={global.country} clientId={global?.config?.paypal?.clientId}/>
        } */}

        {
            global?.config?.showPayMessage && <div className={classes.MarginTop10}>
                {/* <PayMessages customerPayMethod={productVO?.payMethod} money={lower}/> */}
                <PayMessages customerPayMethod={"51"} money={lower} />
            </div>
        }


        {
            selectedProduct?.appExclusiveZone?.message && <div className={classes.AppExclusive} onClick={handleClick}>
                <div>
                    <Iconfont className={classes.AppExclusiveIcon}>&#xe704;</Iconfont>
                    <span className={classes.DiscountMessage}>{selectedProduct?.appExclusiveZone?.message}</span>
                </div>

                <div className={classes.DiscountMessage}>
                    {`${intl.formatMessage({ id: "view_on_app", defaultMessage: "View On App" })} >`}
                </div>
            </div>
        }

        {/* 去掉积分显示 */}
        {/* {
            selectedProduct?.earnPointsMsg && <>
                <div className={classes.EarnPoints}>
                    <span dangerouslySetInnerHTML={{ __html: selectedProduct.earnPointsMsg }}></span>
                    <img src={`${IMAGE_GEEKO_LTD}/chicme/2021111101/question.png`} alt="question" onClick={earnPointsEvent} />
                </div>

                {
                    selectedProduct?.earnPointsDsc && earnPoints && <div className={classes.EarnPointsToast}>
                        <span>{selectedProduct.earnPointsDsc}</span>
                    </div>
                }
            </>
        } */}

        {/* {
            showProm &&
            <DiscountAlert
                show={showProm}
                setShow={setShowProm}
                per={estimatedPercent}
                couponActivity={couponActivity}
                handleAddToCart={handleAddToCart}
                carting={carting}
                selectedVariant={selectedVariant}
                selectedProduct={selectedProduct}
            />
        } */}
    </div>
}

export default BasicInformation;